import { brandEndpointIds } from 'root/src/shared/brand/brand.constants';
import { authenticationTypes } from 'root/src/shared/constants/auth';
import { AuthGroup } from 'root/src/server/util/awsClients/authApiClient.types';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
export const updateBrandRoleEndpoint = {
    [brandEndpointIds.UPDATE_BRAND_ROLE]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: [AuthGroup.Brand, AuthGroup.BrandAdmin],
        payloadSchema: {
            type: 'object',
            properties: {
                userId: { type: 'string' },
                role: {
                    type: 'string',
                    enum: [AuthGroup.BrandUser, AuthGroup.BrandAdmin],
                },
            },
            required: ['userId', 'role'],
        },
        endpointType: otherEndpointType,
        useRequestUserId: true,
    },
};
